module.exports = __webpack_public_path__ + "img/icon-arrow-left.9c64f8c6.svg";